import { render } from "./VideoUpload.vue?vue&type=template&id=b222760a&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"

import "./VideoUpload.vue?vue&type=style&index=0&id=b222760a&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b222760a"]])

export default __exports__